import { type HyperlinkItemContent } from '../hyperlink/hyperlink-read-content.ts';

/**
 * Immutable Page Link presentation in stored page or blog order.
 */
export type PageLinkReadContent = {
  readonly kind: 'page-link';
  readonly links: readonly HyperlinkItemContent[];
};

export const EMPTY_PAGE_LINK_CONTENT: PageLinkReadContent = Object.freeze({
  kind: 'page-link',
  links: Object.freeze([])
});
